import { QueryClient } from "@tanstack/react-query";
import { fetchKeyInformationData } from "@/hooks/product-detail-page/key-information/use-key-information";

const prefetchKeyInformation = (
  queryClient: QueryClient,
  packageId: string,
  neoId: string,
  currencyId: string,
  marketId: string
) => {
  queryClient.prefetchQuery({
    queryKey: ["PDP_KEY_INFORMATION", neoId, packageId, currencyId, marketId],
    queryFn: fetchKeyInformationData(packageId, neoId, currencyId, marketId),
    staleTime: Infinity
  });
};

export default prefetchKeyInformation;